import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";


import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";
//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";

import "assets/scss/custom/react-select.css";
import Select from 'react-select/lib/Async';
// Actions
import {
  accountFilter,
  accountsFetch,
  accountRemove,
  setAccountProfile,
  setAccountIb,
  setAccountClient
} from 'actions/accounts'

import {
  clientsFetchAll
} from 'actions/clients'

import {
  profilesFetchIbs,
  profilesFetchAllFilter,
} from 'actions/profiles'

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    textAlign: 'left',
  }),
   /*control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 250,
    borderBottom: '1px solid silver',
  }),*/
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

class List extends React.Component {
  selected=[]
  state = {
    selected: [],
    remoteFilters:{
      number: '',
    }
  }
  componentDidMount(){
      
      const {accounts: {selectedClientId, selectedClientName, selectedIbId, selectedIbName, selectedProfileId, selectedProfileName}} = this.props
      this.props.filter({size: 10})
      this.setState({...this.state, clientNameSelected: {value: selectedClientId, label:selectedClientName}, ibNameSelected: {value: selectedIbId, label:selectedIbName}, profileNameSelected: {value: selectedProfileId, label:selectedProfileName}})
      this.props.fetch(selectedClientId,selectedIbId)
      //this.props.clientFilter({size: 1000000,sort:{name: 'asc'}})
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        this.props.fetch(this.props.accounts.selectedClientId,this.props.accounts.selectedIbId);
        this.setState({
          ...this.state,
          selected:[],
          alert: <SuccessAlert
            title={`Done!`}
            onConfirm={()=>{this.setState({...this.state,alert:false});}}
          />
        });
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Accounts (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} accounts \n( ${
          this.state.selected.map(id=>this.props.accounts.list.find(e=>e.accountId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.accounts.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.accounts.pageable.page
    })
    this.props.fetch(this.props.accounts.selectedClientId, this.props.accounts.selectedIbId)
  }

  /*
  * onChange select options
  */
  selectProfileChange = ({value, label}) =>{

    this.setState({...this.state, profileNameSelected: {value, label},ibNameSelected: {value:'', label:'Ibs'}})
    this.props.setAccountProfile({profileId: value, profileName: label})
    this.props.filter({size: 10,filter: {profileId: value}});
    this.props.fetch(null,value)

  }

  /*
  * filter by name text
  */
  selectProfileHandleInputChange = (newValue) => {

    this.setState({...this.state, profileName: newValue})
    //this.setState({...this.state,profileId: newValue.profileId});
    return newValue;

  }
  
  /*
  * load select options
  */
  selectProfileLoadOptions = (inputValue, callback) => {

    return this.props.profilesFetchAll(inputValue,false)
        .then((r) => {
          const allOption = {value: '', label: 'All Profiles'}
          const options = r.content.map((i) => { return {value: i.profileId, label: `${i.name} (${i.profileId})`} })
          return [allOption].concat(options)
        }  
    );
  }

  
  /*
  * onChange select options
  */
  selectIbChange = ({value, label}) =>{

    this.setState({...this.state, ibNameSelected: {value, label},clientNameSelected: {value:'', label:'Clients'}})
    this.props.setAccountIb({ibId: value, ibName: label})
    this.props.fetch('',value)
  }

  /*
  * filter by name text
  */
  selectIbHandleInputChange = (newValue) => {

    this.setState({...this.state, ibName: newValue})
    return newValue;
  }

  /*
  * load select options
  */
  selectIbLoadOptions = (inputValue, callback) => {
    
    let { selectedProfileId } = this.props.accounts;
    
    if (selectedProfileId) {
      
      return this.props.profilesFetchIbs(selectedProfileId,false)
          .then((r) => {
            const allOption = {value: '', label: 'All Ibs'}
            const options = r.map((i) => {return {value: i.ib.ibId, label: `${i.ib.firstName} ${i.ib.lastName} (${i.ib.ibId})`}})
            return [allOption].concat(options)
          }  
      );

    } else {

      return [{value: '', label: 'No Ibs'}];
    
    }

  }

  /*
  * onChange select options
  */
  selectClientChange = ({value, label}) =>{

    let { selectedIbId} = this.props.accounts;
    this.setState({...this.state, clientNameSelected: {value, label}})
    this.props.setAccountClient({clientId: value, clientName: label})
    this.props.fetch(value, selectedIbId)
  
  }
  
  /*
  * filter by name text
  */
  selectClientHandleInputChange = (newValue) => {
  
    this.setState({...this.state, clientName: newValue})
    return newValue;
  
  }

  /*
  * load select options
  */
  selectClientLoadOptions = (inputValue, callback) => {

    let { selectedIbId} = this.props.accounts;
    
    if (selectedIbId) {
      
      return this.props.clientsFetchAll(selectedIbId, null, inputValue)
          .then((r) => {
            const allOption = {value: '', label: 'All Clients'}
            const options = r.content.map((i) => {return {value: i.clientId, label: `${i.name} (${i.clientId})`}})
            return [allOption].concat(options)
          }  
      )

    } else {

      return [{value: '', label: 'No Clients'}];
    
    }
  
  }
  

  fetchRemoteFilter(value, key){
    let {selectedClientId, selectedProfileId} = this.props.accounts

    this.setState({
      ...this.state,
      remoteFilters: {
        ...this.state.remoteFilters,
        [key]: value
      }
    })

    if(key === 'number'){
      this.props.fetch(selectedClientId, selectedProfileId, value, false)
    }
    
  }
  render() {
    const {match, accounts} = this.props;
    const selected = this.state.selected
    const filterColumns = [
      {
        name: 'number',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.number
      }
    ]

    return (
      <Card>
        {this.state.alert}
        {
        (!accounts.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={accounts.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={accounts.pageable.totalPages>1?{
            pages:accounts.pageable.totalPages,
            current:accounts.pageable.page+1,
          }:false}
          dark={selected.length>0}
          icon={<StoreMallDirectory/>}
          actions={{
          add: (selected.length===0)
            ? <Link to={`${match.path}/add`}>
                <IconButton>
                  <AddIcon/>
                </IconButton>
              </Link>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('ACCOUNTS_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : ''
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {(accounts.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              <div>
                <div>
                <div style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectProfileLoadOptions}
                      defaultOptions
                      onInputChange={(e) => this.selectProfileHandleInputChange(e)}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectProfileChange(e)}
                      value={this.state.profileNameSelected || ''}
                      placeholder="Search Profiles..."
                    />
                  </div>
                  <div style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectIbLoadOptions}
                      defaultOptions
                      onInputChange={this.selectIbHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectIbChange(e)}
                      value={this.state.ibNameSelected || ''}
                      placeholder="Search Ibs..."
                    />
                  </div>
                  <div className="" style={{minWidth:'200px',maxWidth:'250px', display:'inline-flex', border:'0px solid black', marginRight:'10px'}}>
                    <Select
                      className="react-select-inline"
                      styles={customStyles}
                      loadOptions={this.selectClientLoadOptions}
                      defaultOptions
                      onInputChange={this.selectClientHandleInputChange}
                      backspaceRemoves={true}
                      onChange={(e) => this.selectClientChange(e)}
                      value={this.state.clientNameSelected || ''}
                      placeholder="Search Client..."
                    />
                  </div>
                  
                </div>
                
                <Table
                  tableHeaderColor="primary"
                  sort={accounts.pageable.sort}
                  onSort={(e)=>this.filter({sort:{[e]:accounts.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                  filterColumns={filterColumns}
                  striped
                  tableHead={{ 
                      checkbox:<Checkbox props = {{ 
                        onClick:()=>this.select(accounts.list.map(e=>e.accountId)),
                        checked:this.state.selected.length===accounts.list.length}
                      }/>,
                      /*accountId:"#",*/
                      clientId: 'Client Id',
                      number:"Number", 
                      platform:"Platform",
                      currencyId:"Currency"
                    }}
                  tableData={accounts.list.map((e,i) => [ 
                      <Checkbox props = {{ onClick:()=>this.select(e.accountId), checked:this.state.selected.indexOf(e.accountId)>-1 }}/>,
                      /*e.accountId,*/ 
                      e.clientId, 
                      e.number,
                      e.platform.name,
                      e.currency.name
                    ] )}/>
              </div>
            )}

        </CardBody>
       { 
         accounts.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={accounts.pageable.totalPages>1?{
              pages:accounts.pageable.totalPages,
              current:accounts.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  accounts: state.accounts,
  clients: state.clients.list,
  ibs: state.ibs.list,
  profiles: state.profiles,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(accountFilter(filter)),
  setAccountProfile: (data) => dispatch(setAccountProfile(data)),
  setAccountIb: (data) => dispatch(setAccountIb(data)),
  setAccountClient: (data) => dispatch(setAccountClient(data)),
  fetch: (clientId, ibId, filter, loading) => dispatch(accountsFetch(clientId, ibId, filter, loading)),
  remove: (id) => dispatch(accountRemove(id)),
  clientsFetchAll: (ibId, profileId, clientName) => dispatch(clientsFetchAll(ibId, profileId, clientName)),
  profilesFetchAll: (profileName, loading) => dispatch(profilesFetchAllFilter(profileName, loading)),
  profilesFetchIbs: (profileId, loading) => dispatch(profilesFetchIbs(profileId, loading)),
  
})
export default withStyles(buttonsStyle)(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Accounts/List.jsx